import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {CenteredHeader, CenteredInfo, CenteredLayout} from '../../layout/centered/components';
import MessageBox from '../components/MessageBox';

const ContactConfirmation: React.FC = () => {
  const {t} = useTranslation();
  return (
    <CenteredLayout sectionId="contact-confirmation-section">
      <CenteredHeader
        title={t('common.pages.contactConfirmation.title')}
        subtitle={t('common.pages.contactConfirmation.subtitle')}
      />

      <MessageBox
        icon="fa fa-check-circle"
        message={t('common.pages.contactConfirmation.message')}
      />

      <CenteredInfo className="mt-8">
        <Link
          className="text-gray-800 hover:underline cursor-pointer font-medium"
          to="/"
        >
          {t('common.pages.contactConfirmation.backToHome')}
        </Link>
      </CenteredInfo>
    </CenteredLayout>
  );
};

export default ContactConfirmation;

